<template>
    <ApprovedRequests></ApprovedRequests>
</template>
<script>
    import ApprovedRequests from '@/components/ApprovedRequests.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            ApprovedRequests
        }
    }
</script>